import { useState } from "react";

import { EyeIcon } from "components/Icons";
import FormField from "./FormField";
import { cn, colors } from "tools/ui";

const style =
  "h-10 rounded-lg w-full py-2 px-2 text-gray-700 dark:bg-neutral-100 dark:border-none border border-slate-300 focus:outline-none focus:border focus:border-cyan-500";

/**
 *
 * @param {*} props -
 * @param {Boolean} readOnly -
 * @param {String} type -
 * @param {String} label -
 * @param {String} name -
 * @param {String} placeholder -
 * @param {String} value -
 * @param {Function} onChange -
 * @param {Boolean} translate -
 * @returns Component PasswordField
 */

function PasswordField(props) {
  const { name, data, mode, label, placeholder, readOnly, onChange, colSpan } =
    props;
  const [showPassword, setShowPassword] = useState(false);

  // let _value = data.value || "";
  // if (_value && translate) {
  //   const _valueRef = `${ctxView.model}.${_value}`;
  //   _value = intl.msgs[_valueRef] || _value;
  // }

  let _color = "bg-white";

  if (readOnly) {
    _color = colors.readOnly;
  }
  const _style = style;

  function handleChange(event) {
    const _value = event.target.value;
    data.value = _value;
    onChange(name, _value);
  }

  function onBlur(event) {
    const _value = event.target.value;
    if (onChange) {
      onChange(name, _value);
    }
  }

  return (
    <FormField
      id={name}
      label={label}
      name={name}
      required={props.required}
      colspan={colSpan}
      mode={mode}
    >
      <div className="relative rounded-md">
        <input
          key={name}
          id={name}
          name={name}
          className={cn(_color, _style)}
          type={showPassword ? "text" : "password"}
          value={data}
          onChange={handleChange}
          onBlur={onBlur}
          disabled={readOnly ?? false}
          placeholder={placeholder ?? ""}
        />
        <div
          className="absolute hover:cursor-pointer inset-y-0 right-0 flex items-center pr-3"
          onClick={() => setShowPassword(!showPassword)}
        >
          <EyeIcon
            className="h-5 w-5 text-gray-500 fill-current"
            aria-hidden="true"
          />
        </div>
      </div>
    </FormField>
  );
}

export default PasswordField;
